import { styled } from '@mui/material/styles';
import { alpha } from '@mui/material';
import { BadgeTextContainer } from 'pages/document/page/components/StyledComponents';

export const PaidBadgeTextContainer = styled(BadgeTextContainer, {
  label: 'PaidBadgeText',
  shouldForwardProp: (propName) => !['fontSize'].includes(propName),
})(({ theme }) => ({
  backgroundColor: alpha(theme.palette.secondary.main, 0.5),
}));
